<template>
    <div>
        <CommonPopupFrame :isOpen="isOpen" :closeCompleteAction="closeCompleteAction" :changeBottom="0">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="margin-top: 16px; padding: 0 18px; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center; position: relative; border-bottom: 1px solid #f5f5f5;">
                <div @click="closeCompleteAction">
                    <img style="width: 40px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                </div>
                <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">스케줄 자세히 보기</div>
            </div>
            <div @touchmove.stop="() => { }" style="flex: 1; overflow-y: scroll; padding: 16px 20px;">
                <div style="padding-bottom: 14px; border-bottom: 1px solid #f5f5f5;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <div style="width: 10px; height: 10px; border-radius: 50%; background-color: var(--color-main); flex-shrink: 0"></div>
                        <div style="display: flex; align-items: center; justify-content: space-between; flex: 1;">
                            <div style="font-weight: 700; font-size: 20px; line-height: 28px;">{{ scheduleDetail.title }}</div>
                            <div v-if="is_me_creator" style="position: relative;">
                                <SoccerJoinBookMark :showPopMenu="showPopMenu" :imagePath="'option_black'"></SoccerJoinBookMark>
                                <MemberTalkPopMenuOption v-if="isShowPopMenu" :right="0" :top="25" v-bind="popMenuOptions"></MemberTalkPopMenuOption>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <img style="width: 14px;" :src="require('@/assets/img/schedule_location.png')" alt="">
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ scheduleDetail.place_name }}</div>
                    </div>
                    <div style="margin-top: 4px;">
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500; color: #606060;">{{ fullYear }}</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px; ">{{ begin_time }} ~ {{ end_time }}</div>
                    </div>
                </div>
                <div style="padding-top: 14px; border-bottom: 1px solid #f5f5f5; padding-bottom: 11px;">
                    <div style="font-size: 14px; font-weight: 700;line-height: 24px;">함께하는 멤버</div>
                    <div style="font-size: 14px;font-weight: 500;line-height: 24px;">{{ scheduleDetail.cur_cnt }}명</div>
                    <div style="margin-top: 6px; display: flex; gap: 15px; overflow-x: scroll; width: calc(100% + 40px); margin-left: -20px; padding: 0 20px;">
                        <div class="image_wrap" v-for="each, i in scheduleMembers" :key="i">
                            <ProfileImage :writerType="each.member_type" :imagePath="each.image_path"></ProfileImage>
                            <div style="font-size: 12px;font-weight: 700;line-height: 24px; white-space: nowrap; margin-top: 2px;">{{ each.nic_name }}</div>
                        </div>
                    </div>
                </div>
                <div style="padding-top: 16px; border-bottom: 1px solid #f5f5f5; padding-bottom: 14px;">
                    <div style="font-size: 14px;font-weight: 700;line-height: 20px;">내용</div>
                    <div style="font-size: 14px;font-weight: 500;line-height: 24px;">{{ scheduleDetail.contents }}</div>
                </div>
                <div style="padding-top: 16px;">
                    <div style="height: 160px; background-color: white; border-radius: 12px;" id="schedule_detail_map"></div>
                </div>
            </div>
            <div @click="confirmEnterSchedule(); $Util.sendEventClick('멤버_상세_스케줄_자세히보기_참여하기');" v-if="!scheduleDetail.is_me_joined" class="common_btn">스케줄 참여하기</div>
            <div v-else style="color: #d9d9d9;" class="common_btn">참여중</div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ProfileImage from '@/components/common/ProfileImage'
import NaverMap from "@/modules/NaverMap";
import SoccerJoinBookMark from './SoccerJoinBookMark.vue';
import MemberTalkPopMenuOption from '@/components/common/MemberTalkPopMenuOption';
import ResponseCode from '../../../ResponseCode';
import { FORM_MODE } from '../../../Constants';

export default {
    name: 'MemberTalkScheduleDetail',
    components: {
        CommonPopupFrame, ProfileImage, SoccerJoinBookMark, MemberTalkPopMenuOption
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        scheduleIdx: {
            type: [Number, String],
            default: ''
        },
        is_me_creator: {
            type: Boolean,
            default: false
        },
        hideJoinDetail : {
            type : Function,
            default : () => {}
        }
    },
    created() {
        this.deleteSchedule = this.$Once(this.deleteSchedule);
    },
    data() {
        return {
            scheduleDetail: {},
            scheduleMembers: [],
            fullYear: '',
            begin_time: '',
            end_time: '',
            popMenuOptions: {},
            isShowPopMenu: false,
            myIdx: -1
        }
    },
    methods: {
        completeActionDetail(mode) {
            this.getScheduleDetail()
            this.closeCompleteAction(mode)
        },
        showPopMenu() {
            this.isShowPopMenu = true
            if (!this.is_me_creator) {
                this.popMenuOptions = {
                    labelAndAction: [
                        {
                            label: '매니저 권한으로 삭제하기',
                            action: () => {
                                this.isShowPopMenu = false
                                this.cofirmDelete()
                            },
                            imagePath: require('@/assets/img/delete_color.png'),
                            imageWidth: 12,
                            fontColor: "var(--color-main)"
                        },
                    ],
                    closeAction: () => { this.isShowPopMenu = false }
                }
            } else {
                this.popMenuOptions = {
                    labelAndAction: [
                        {
                            label: '수정하기',
                            action: () => {
                                this.$Util.sendEventClick('멤버_상세_스케줄_자세히보기_수정하기');
                                this.$GlobalStore.addModal('NewMakeMercenarySchedule', { scheduleIdx: this.scheduleIdx, isJoin: true, isModifyMemberTalkSchedule: true, completeAction: this.completeActionDetail })
                                this.isShowPopMenu = false
                            },
                            imagePath: require('@/assets/img/modify.png'),
                            imageWidth: 12,
                        },
                        {
                            label: '멤버톡에 공유하기',
                            action: async () => {
                                this.$Util.sendEventClick('멤버_상세_스케줄_자세히보기_공유하기');
                                this.isShowPopMenu = false
                                const parameters = {};
                                parameters.join_schedule_idx = this.scheduleIdx;
                                const res = await this.$Axios.post('/api/join/schedule/share', parameters);
                                if(res.data.code === ResponseCode.SUCCESS){
                                    this.hideJoinDetail();
                                }else if(res.data.code === ResponseCode.FAIL){
                                    this.$GlobalStore.showAlert(res.data.msg);
                                }
                            },
                            imagePath: require('@/assets/img/share.png'),
                            imageWidth: 12,
                        },
                        {
                            label: '삭제하기',
                            action: () => {
                                this.$Util.sendEventClick('멤버_상세_스케줄_자세히보기_삭제하기');
                                this.cofirmDelete()
                                this.isShowPopMenu = false
                            },
                            imagePath: require('@/assets/img/delete_color.png'),
                            imageWidth: 11,
                            fontColor: "var(--color-main)"
                        },
                    ],
                    closeAction: () => { this.isShowPopMenu = false }
                }
            }
        },
        confirmEnterSchedule() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">멤버톡 스케줄 참여하기</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>멤버톡에서 진행되는 스케줄에<br>참여할까요?</div>`
            this.$GlobalStore.showConfirm(html, () => {
                this.$Util.sendEventClick('멤버_상세_스케줄_자세히보기_참여하기_확인');
                this.enterSchedule()
            }, '스케줄 참여하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { });
        },
        async enterSchedule() {
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetail.idx)

            const res = await this.$Axios.post('/api/join/schedule/apply', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.showAlert('참여가 완료되었습니다.')
                this.getScheduleDetail()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        cofirmDelete() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄을 삭제할까요?</div>`;
            this.$GlobalStore.showConfirm(html, () => {
                this.$Util.sendEventClick('멤버_상세_스케줄_자세히보기_삭제하기_확인');
                this.isShowPopMenu = false
                this.deleteSchedule()
            }, '스케줄 삭제', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { });
        },
        async deleteSchedule() {
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetail.idx)

            const res = await this.$Axios.post('/api/join/schedule/delete', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeCompleteAction(FORM_MODE.DELETE)
                this.$GlobalStore.showAlert('스케줄이 삭제되었습니다.')
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async getScheduleDetail() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleIdx

            if (this.scheduleIdx === '' || !this.scheduleIdx) {
                this.$GlobalStore.showAlert('삭제된 스케줄입니다.');
                this.closeCompleteAction(FORM_MODE.DELETE);
                return;
            }

            const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters })
            if(!res.data.join_schedules){
                this.$GlobalStore.showAlert('삭제된 스케줄입니다.');
                this.closeCompleteAction(FORM_MODE.DELETE);
                return;
            }

            const scheduleDetail = res.data.join_schedules
            const scheduleMembers = res.data.join_schedule_members

            this.scheduleDetail = scheduleDetail
            this.scheduleMembers = scheduleMembers

            this.is_me_creator = this.$GlobalStore.checkIsMe(scheduleDetail.creator_idx, scheduleDetail.creator_type);

            const join_date = scheduleDetail.join_begin_date_time.split(' ')[0]
            const begin_time = scheduleDetail.join_begin_date_time.split(' ')[1]
            const end_time = scheduleDetail.join_end_date_time.split(' ')[1]
            const slice_begin_time = begin_time.slice(0, begin_time.lastIndexOf(':'))
            const slice_end_time = end_time.slice(0, end_time.lastIndexOf(':'))

            this.fullYear = this.$Util.getMMDDDayHangulStr(join_date)
            this.begin_time = slice_begin_time
            this.end_time = slice_end_time

            this.naverMap = new NaverMap();
            const options = {
                pinchZoom: false,
                scrollWheel: false,
                draggable: false,
            };
            this.naverMap.initMap('schedule_detail_map', this.scheduleDetail.gps_latitude, this.scheduleDetail.gps_longitude, options);
            this.naverMap.setCenterMarker(this.scheduleDetail.gps_latitude, this.scheduleDetail.gps_longitude);
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.scheduleDetail = {}
                this.scheduleMembers = []
                this.myIdx = this.$GlobalStore.loginInfo().idx
                this.getScheduleDetail()
            }

            if (!newVal && this.isShowPopMenu) {
                this.isShowPopMenu = false
            }
        }
    }
}
</script>

<style scoped>
.common_btn {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: #f5f5f5;
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 12px;
    color: var(--color-main);
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 33px;
}

.image_wrap {
    text-align: center;
}

.image_wrap img {
    width: 40px;
    height: 40px;
}
</style>